import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Dropdown from '../dropdown/dropdown';
import Button from '../button/button';

import styles from './filter.module.scss';

const FilterDropdownContent = ({ term, handleInputChange, checked }) => (
  <li>
    <label className={styles.filterOption} htmlFor={term.drupal_id}>
      <input
        className={styles.checkbox}
        id={term.drupal_id}
        type="checkbox"
        checked={checked}
        onChange={handleInputChange}
      />
      <span className={styles.controlIndicator} />
      <span className={styles.checkboxlabel}>{term.name || term.title}</span>
    </label>
  </li>
);

FilterDropdownContent.propTypes = {
  term: PropTypes.object,
  handleInputChange: PropTypes.func,
  checked: PropTypes.bool,
};

const Filter = ({
  filter,
  selectedFilters,
  handleInputChange,
  submitFilter,
  isActive
}) => {
  const buttonClass = classnames(styles.button, {
    [styles.active]: isActive
  });

  return (
    <li>
      <Dropdown
        className={buttonClass}
        buttonContent={filter.title}
        id={`filter-${filter.field}`}
      >
        <form className={styles.filterDropdown}>
          <ul>
            {filter.data.map((term) => (
              <FilterDropdownContent
                key={`${term.node.drupal_id}`}
                term={term.node}
                checked={Boolean(selectedFilters[term.node.drupal_id])}
                handleInputChange={(e) => {
                  handleInputChange(e, filter.field);
                }}
              />
            ))}
          </ul>
          <Button
            className={styles.updateButton}
            size="small"
            type="submit"
            onClick={submitFilter}
          >
            Update
          </Button>
        </form>
      </Dropdown>
    </li>
  );
};

Filter.propTypes = {
  filter: PropTypes.object,
  selectedFilters: PropTypes.object,
  handleInputChange: PropTypes.func,
  submitFilter: PropTypes.func,
  isActive: PropTypes.bool
};

export default Filter;
